declare global {
  interface Window {
    /** Set only in the self-contained share build: every data URL, pre-inlined. */
    __DATA?: Record<string, unknown>;
    /** Share build: per-page V4 font data URLs (slice only — absent pages stay absent). */
    __V4?: Record<number, string>;
    /** Share build page cap; the full build always has all 604 pages. */
    __MAXPAGE?: number;
  }
}

export const FULL_MUSHAF_PAGE_COUNT = 604;

/** The last mushaf page available in this build (share builds carry a slice). */
export function maxMushafPage(): number {
  return window.__MAXPAGE || FULL_MUSHAF_PAGE_COUNT;
}

/**
 * Fetches a JSON resource exactly like the legacy runtime: the share build's
 * pre-inlined `window.__DATA` wins, otherwise the network, with a non-OK
 * response thrown as an error naming the URL.
 */
export function fetchQuranJson<T>(url: string): Promise<T> {
  if (window.__DATA && Object.prototype.hasOwnProperty.call(window.__DATA, url)) {
    return Promise.resolve(window.__DATA[url] as T);
  }
  return fetch(url).then((response) => {
    if (!response.ok) throw new Error(url);
    return response.json() as Promise<T>;
  });
}
